export const environment = {
  production: true,
  baseNotaria: 'https://notariagaldosotomayor.pe/verificar/#/',
  baseUrlAPI : 'https://notariagaldosotomayor.pe/gestor/backend/'
};
